import './custom.scss';
import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

const injectGA = () => {
    if (typeof window == 'undefined') {
        return;
    }
    window.dataLayer = window.dataLayer || [];
    function gtag() {
        window.dataLayer.push(arguments);
    }
    gtag('js', new Date());

    gtag('config', 'G-PMFQYVEGNH');
};

root.render(
    <BrowserRouter basename={baseUrl}>
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-PMFQYVEGNH" />
        <script>{injectGA()}</script>
        <App />
    </BrowserRouter>
);

serviceWorkerRegistration.unregister();
reportWebVitals();
